import BaseDetail from '@/views/base/baseDetail';
import { mapGetters } from 'vuex';
import { popup } from '@/mixins/common/popup';
import { ModuleContext } from '@/stores/moduleConst';
import { shortkeyStatusbar } from '@/mixins/common/shortkeyStatusbar';
import IndexedDB from '@/commons/indexedDB';
import npsFunction from '@/commons/NPSFunction';
import layoutApi from '@/apis/system/layoutAPI';
import IntegrationACTApi from '@/apis/integration/integrationACTApi';
import _ from 'lodash';
import maintainDatabaseFn from '@/commons/validateMaintainDatabase.js';
import {
  showError,
  showConfirm,
  showConfirmCancel,
  showConfirmValidateCustom,
  showConfirmValidate,
  showAlertEscapsed,
} from '@/commons/globalMessage';
import popupUtil from '@/commons/popupUtil';

export default {
  extends: BaseDetail,
  name: 'BaseDetailPopup',
  mixins: [popup, shortkeyStatusbar],
  data: function () {
    const me = this;
    return {
      maximum: false,
      editViewDefaultMode: me.$ms.constant.FormState.Edit,
      /**
       * Tên router form danh sách sẽ quay lại
       * Sử dụng khi mở link detail dạng f5 thì k có trang danh sách gốc -> quay về mặc định hình
       */
      backRouter: null,
      /**
       * CLick save và đóng form
       */
      saveAndClose: false,
      taxRateValues: [],
    };
  },
  mounted: async function () {
    const me = this;
    window._listDetailPopup = me; // TODO: Trong code không dùng cái này (chỉ dùng để debug)
    await me.saveCurrentParam(me._formParam);
    me.show(me._formParam, me._formParam?.options);

    let taxEnums = _.cloneDeep(me.$ms.constant.TaxRateInventory);
    me.taxRateValues = Object.values(taxEnums);
  },
  computed: {
    ...mapGetters(ModuleContext, ['Context']),
    /** Nhấn Esc để đóng form */
    escToClose: function () {
      return !this.showStep;
    },
  },
  methods: {
    /**
     * Trước khi mở form
     * Xử lý tham số truyền lên. Dùng để load dữ liệu binding
     */
    beforeOpen(e, close) {
      const me = this;
      me._popup = me.$vfm.dynamicModals[me.$vfm.dynamicModals.length - 1];
      me._formParam = e.ref.params._rawValue;
    },

    /**
     * Thay đổi url cho phù hợp với link form
     */
    changeUrl(id) {
      const me = this;

      //Không có khai báo thì bỏ qua luôn
      if (!me.backRouter) {
        return;
      }

      if (me._formParam.isDetailPopup) {
        delete me._formParam.isDetailPopup;
        me._formParam.isBackRouter = true;
        me._formParam.currentPath && (me.backRouter = me._formParam.currentPath);

        return;
      }
      /** Lấy id đã lưu lại để khi thay đổi mode mà id không thay đổi thì ko cần push vào history */
      let saveId = history.state?.id;

      if (!saveId || id != saveId) {
        //Check xem nếu ko có _currentPath mới thực hiện gắn lại
        //Check xem có truyền current path để back về hay ko: Xử lý TH từ popup này show sang popup khác
        me._currentPath = me._formParam.currentPath || location.pathname;

        let url = [];
        url.push('/popup/', me._formParam.name.toLowerCase());
        id && url.push('/', id);
        let link = me.$ms.commonFn.getFullLink(url.join(''));

        /** Lưu vào history client */
        history.pushState({ prv: location.href, id }, '', link);
      }
    },

    /**
     * Hiển thị form chi tiết khi click vào ô (nếu có config linkedForm)
     * dtnga3 (14.07.2022)
     */
    viewLinkedForm(col, dataRow) {
      // Lấy tên form tùy theo đặc tính từng bản ghi
      let formName = this.getLinkedFormCustom(dataRow.ref_type_voucher);

      if (!formName && col && col.linkedForm && col.linkedForm != '') {
        formName = col.linkedForm;
      }
      if (dataRow && formName && formName != '') {
        this.viewDetail(dataRow, formName);
      }
    },

    /**
     * custom tên form theo đặc thù từng bản ghi
     * @param {*} dataRow dòng dữ liệu được click
     * dtnga3 (15.07.2022)
     */
    getLinkedFormCustom(dataRow) { },
    /**
     * Xem
     * */
    viewDetail(record, formName) {
      const me = this;

      if (formName) {
        //kiểm tra phân quyền
        me.checkActionPermissionAlert(me.$ms.constant.Permission.View);
        // lấy tên form detail để show
        // dtnga3 (14.07.2022) Nếu bên ngoài có truyền vào tên form detail thì sẽ thực hiện show form đó
        let formDetailName = formName && formName != '' ? formName : me.getFormDetailName(record);

        let param = me.getDetailParameter(formDetailName, this.$ms.constant.FormState.View, record);

        me.showDetail(formDetailName, param, {
          submit: function (saveResult, saveParam) {
            if (saveResult.Success) {
              me.afterSaveView(record, saveResult, saveParam);
            }
          },
        });
      } else {
        me.super('view', BaseDetail, record);
      }

    },
    /**
     * TPNAM 26.01.2024
     * Lấy tham số khi mở form chi tiết
     * */
    getDetailParameter(formName, mode, defaultData) {
      const me = this;

      let param = {
        data: defaultData || null,
      };

      switch (mode) {
        case me.$ms.constant.FormState.Duplicate:
        case me.$ms.constant.FormState.Edit:
        case me.$ms.constant.FormState.View:
          if (me.$store.state[me.module]._config.field.key) {
            param.id = defaultData ? defaultData[me.$store.state[me.module]._config.field.key] : '';
          }
          break;
      }
      param.mode = mode;
      return param;
    },
    /**
     * Hàm show các popup theo tên lấy đường dẫn từ hàm getPopupomponent
     * @param name tên của component
     * TPNAM 26.01.2024
     */
    showDetail(name, data, option) {
      const me = this;

      if (me.isCacheParam) {
        me._indexDb = me._indexDb || new IndexedDB();
        let key = [name, data.id || ''].filter(x => x).join('_');
        let save = Object.assign({}, data, {
          module: me.module,
          currentPath: location.pathname,
        });
        me._indexDb.set(key, save);
      }

      popupUtil.show(name, data, me.getPopupOption(name, option));
    },

    /**
     * TPNAM 26.01.2024
     * Cho phép detail gọi tới submitDetailCallback của danh sách sau khi cất xong
     */
    getPopupOption(name, option) {
      const me = this;
      return {
        submit: me.submitDetailCallback,
      };
    },

    /**
     * Lưu param hiện tại để khi refresh thì lấy lại param
     * @author nnnam - 15/9/2022
     */
    async saveCurrentParam(param) {
      const me = this;

      if (me.isCacheParam) {
        me._indexDb = me._indexDb || new IndexedDB();

        // /** Nếu module detail khác module cha thì set module cha (listModule) để lấy dữ liệu */
        var key = me.getKeyCache(me.$options.name, param.id);

        if (param.isDetailPopup) {
          var saveParam = (await me._indexDb.get(key)) || {};
          let clone = _.cloneDeep(param);
          Object.assign(param, saveParam, clone);
        }

        let pr = _.cloneDeep(param);
        delete pr.isDetailPopup;

        me._indexDb.set(key, pr);
      }
    },

    /**
     * Xử lý các action click trên form
     * @param {*} command
     * NCPHUOC 05/04/2022
     */
    async commandClick(command) {
      const me = this;
      switch (command) {
        case this.$ms.constant.Command.Save:
          me.save(this.$ms.constant.SaveMode.Save);
          break;
        case this.$ms.constant.Command.SaveAdd:
          me.save(this.$ms.constant.SaveMode.SaveNew);
          break;
        case this.$ms.constant.Command.SaveView:
          me.save(me.$ms.constant.SaveMode.SaveView);
          break;
        case this.$ms.constant.Command.UnPosted:
          //Thực hiện validate đang bảo trì dữ liệu trước khi thực hiện chức năng
          maintainDatabaseFn.validateMaintainDatabase(command, me.model).then(res => {
            if (!res) {
              return;
            }

            me.onUnPosted(me.model, true, null);

            this.pushTrans(command);
          });
          return;
        case this.$ms.constant.Command.Posted:
          //Thực hiện validate đang bảo trì dữ liệu trước khi thực hiện chức năng
          maintainDatabaseFn.validateMaintainDatabase(command, me.model).then(res => {
            if (!res) {
              return;
            }

            me.onPosted(me.model, true, null);

            this.pushTrans(command);
          });
          return;
        case this.$ms.constant.Command.InsertRowGrid:
          const fakeInputGrid = this.$el.querySelector('.ms-editor .input-fake-first');
          //Focus vào input fake để active cell
          if (fakeInputGrid) {
            fakeInputGrid.focus();
          }
          break;
        case this.$ms.constant.Command.DeleteRowGrid:
          if (me._gridDetails) {
            const keys = Object.keys(me._gridDetails);
            if (keys.length > 0) {
              //Mặc định vào grid đầu tiên
              const refKey = me._gridDetails[keys[0]];
              const $refGrid = me.$refs[refKey];
              if ($refGrid && typeof $refGrid.getData === 'function') {
                const rows = $refGrid.getData();
                if (Array.isArray(rows) && rows.length > 0 && typeof $refGrid.deleteRow === 'function') {
                  $refGrid.deleteRow(rows[rows.length - 1]);
                }
              }
            }
          }
          break;
        case this.$ms.constant.Command.Add:
          break;
        case this.$ms.constant.Command.Postpone:
          this.editMode = this.$ms.constant.FormState.View;
          /** Submit grid trước khi undo */
          me.submitGridEditor && (await me.submitGridEditor(this.editMode));
          this.resetData();
          break;
        default:
          //TODO Show tính năng phát triển
          break;
      }
      this.pushTrans(command);
    },
    /**
     * Submit các grid đang edit
     * dtnga3 (04.10.2022)
     */
    submitGridEditor() {
      try {
        const me = this,
          { _gridDetails } = me;
        const submitAction = [];
        if (_gridDetails) {
          for (const key in _gridDetails) {
            //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
            if (Object.hasOwnProperty.call(_gridDetails, key)) {
              const keyRef = _gridDetails[key];
              const $gridRef = me.$refs[keyRef];
              if ($gridRef && typeof $gridRef.submitEditor === 'function') {
                submitAction.push($gridRef.submitEditor());
              }
            }
          }
        }

        return Promise.all(submitAction);
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Trước khi đóng form
     * Xử lý checkchange
     * NCPHUOC 27/05/2022: Ở mode view sẽ không check change
     */
    beforeClose(e) {
      const me = this;

      //Thêm hàm cần làm gì trước khi đóng form thì xử lý ở đây, TVDAT 14/12/2022
      me.customBeforeClose();

      if (!me._suppendClose) {
        //check change
        if (me.editMode === me.$ms.constant.FormState.View && !me.isQuickEditVoucher) {
          me.closeChangeUrl();
          //Call hàm callback trước khi đóng form
          me.callbackBeforeClose();
          me?.options?.close && me.options.close();
          return;
        }
        let change = me.checkChanges();
        if (change) {
          e.stop();
          //show confirm box
          me.showQuestionBeforeClose();
          return;
        } else {
          me.customWhenNoChange();
        }
      }

      //Call hàm callback trước khi đóng form
      me.callbackBeforeClose();

      delete me._suppendClose;

      //xử lý link callback
      me.closeChangeUrl();
      me?.options?.close && me.options.close();
    },

    /**
     * Hàm callback trước khi đóng form
     * Mục đích tạo hàm này để baseDetailVoucher override để không ảnh hưởng đến base khác
     * NVTUAN1 12.05.2023
     */
    callbackBeforeClose() { },

    /**
     * Xử lý trước khi đóng form
     * TVDAT 14/12/2022
     */
    async customBeforeClose() { },
    /**
     * Xử lý khi dừng resize cột trong grid thì lưu lại config layout
     * @author TVDAT - 19/04/2023
     */
    async onResizeStop(columns) {
      try {
        let me = this;
        if (columns && Array.isArray(columns) && columns.length > 0) {
          let config;
          if (me.layout.tag == me.currentLayout) {
            config = { ...me.layout };
          } else {
            config = { ...me.layoutOther };
          }
          delete config.code;
          delete config.is_system;
          columns.forEach(col => {
            delete col._width;
          });
          let configs = JSON.parse(config.config);
          columns.forEach(x => {
            let index = configs.findIndex(y => y.dataField == x.dataField);
            configs[index].width = x.width;
          });
          config.config = JSON.stringify(configs);
          //Lấy thông tin user
          const data = me.$store.getters['context/Context'];
          config.user_id = data?.UserID;
          //Gán lại cho đúng tag
          config.tag = me.currentLayout;
          me.setCacheLayoutTemplate(me.currentLayout, config);
          await layoutApi.replace(config);
        }
      } catch (error) { }
    },
    /**
     * Xử lý khi không có dữ liệu thay đổi và đóng form
     * tbngoc 15.04.2023
     */
    async customWhenNoChange() { },
    /**
     * Xử lý url khi đóng popup
     * NXCHIEN 10.07.2022: Sửa lại back đúng đến url
     * NXCHIEN 10.04.2023: Sửa lỗi back URL 2 lần ko tìm thấy history gây lỗi link domain+ undefined
     */
    closeChangeUrl() {
      const me = this;
      if (me._disableChangeUrl) {
        delete me._disableChangeUrl;
        return;
      }
      if (!me._formParam.isBackRouter && me._currentPath) {
        if (me._formParam.customBackRouter) {
          //history.pushState({ prv: location.href }, '', me._formParam.backRouter);
          me.$router.push(me._formParam.backRouter);
          setTimeout(() => {
            if (
              me._formParam.backRouterFromProcessFunc &&
              typeof me._formParam.backRouterFromProcessFunc === 'function'
            ) {
              me._formParam.backRouterFromProcessFunc();
            }
          }, 100);
        } else {
          history.pushState({ prv: location.href, current: me._currentPath }, '', me._currentPath);
        }
      } else {
        let routerArgs = '/';
        if (me.backRouter) {
          if (me.backRouter.indexOf('/') > -1) {
            routerArgs = me.backRouter;
          } else {
            routerArgs = {
              name: me.backRouter,
            };
          }
          me.$router.push({ path: routerArgs, replace: true });
        }
      }
    },

    /**
     * Show câu cảnh báo hỏi khách hành khi bấm nút hủy và có thay đổi dữ liệu
     */
    showQuestionBeforeClose() {
      var me = this,
        msg = me.getCloseConfirmMessage();
      showConfirmCancel(msg, 'Dữ liệu đã thay đổi').then(answer => {
        switch (answer) {
          case true:
            //cất & đóng
            if (me.validateBeforeSave && typeof me.validateBeforeSave == 'function') {
              me.validateBeforeSave(me.$ms.constant.SaveMode.Save);
            } else {
              me.save(me.$ms.constant.SaveMode.Save);
            }
            break;
          case false:
            //đóng không cất
            me.hide();
            break;
        }
      });
    },

    /*
     * Lấy câu thông báo trước khi đóng form
     */
    getCloseConfirmMessage() {
      return this.$tm('i18nBaseForm.Message.ConfirmSaveChangeClose');
    },

    /**
     * Đóng form nhưng không kiểm tra thay đổi
     */
    hide(disableChangeUrl) {
      const me = this;
      /** Ẩn không thay đổi url */
      if (disableChangeUrl && typeof disableChangeUrl !== 'boolean') {
        disableChangeUrl = false;
      }
      me._disableChangeUrl = disableChangeUrl;
      me._suppendClose = true;
      me._popup.value = false;

      me.$nextTick(() => {
        me._suppendClose = true;
        delete me._popup;
      });
    },

    setHelpId(helpId) {
      window._helpId = helpId;
    },

    /**
     * Hàm mở popup
     * thực hiện set giá trị cho model và oldData
     * chuyển biến hiện thị popup thành true
     * Created by LTDAT(22.06.2020)
     *  */
    show(param, options) {
      let me = this;
      //giữ lại option cho các tình huống cần sử dụng
      me.options = options;
      me.param = {};
      if (param) {
        Object.assign(me.param, param);
      }
      //reset cờ có dữ liệu thay đổi
      me.isChangeData = false;

      //mở form từ báo cáo không
      me.isShowFromReport = param?.isShowFromReport || false;

      //show popup
      me.active = true;

      //load dữ liệu
      me.editMode =
        typeof param.mode === 'number' ? param.mode : param.id ? me.editViewDefaultMode : me.$ms.constant.FormState.Add;
      switch (me.editMode) {
        case me.$ms.constant.FormState.Add:
          me.add(param);
          break;
        case me.$ms.constant.FormState.Edit:
          me.edit(param);
          break;
        //Thêm dữ liệu cho mode view
        case me.$ms.constant.FormState.View:
          me.view(param);
          break;
        case me.$ms.constant.FormState.Duplicate:
          me.duplicate(param);
          break;
        case me.$ms.constant.FormState.Copy:
          me.copy(param);
          break;
        default:
          throw 'Not Implement exception with mode ' + mode;
      }
    },
    /**
     * validate các nghiệp vụ bussiness
     */
    validateBusiness(saveParam, action){
      return {};
    },
    /**
     * @override
     * Xử lý sau khi cất
     * */
    saveSuccess(result, param, action) {
      const me = this;
      // me.hide();
      // return;
      if (me.options && typeof me.options.submit === 'function') {
        me.options.submit(result, param, action);
      }
      // Xử lý cập nhật bản ghi được chọn
      if (me.options && typeof me.options.submitDetail === 'function') {
        me.options.submitDetail(param, me.$store.state[me.module]._config.field.key);
      }

      me.isChangeData = true;

      switch (param.Mode) {
        case me.$ms.constant.SaveMode.Save:
          me.afterSubmitModeSave(result, param);
          break;
        case me.$ms.constant.SaveMode.SaveNew:
          me.afterSubmitModeSaveNew(result, param);
          break;
        // pvduy 04/03/2021 cất thành công tại mode view
        case me.$ms.constant.SaveMode.SaveView:
          me.afterSubmitModeView(result, param);
          this.addBuPlanWithdrawReferenceInvoiceAct();
          break;
        default:
          me.hide();
          break;
      }

      // Sửa nhanh chứng từ - lhphong 29.05.2023
      if (me.isQuickEditVoucher) {
        me.quickEditVoucher(result);
      }

      //Thực hiện một số chức năng sau khi cất thành công
      me.afterSaveSuccess(result);

      me.super('saveSuccess', BaseDetail, result, param, action);

      // hướng dẫn 
      if (me.steps && me.stepsDynamic) {
        me.stepsDynamic = me.steps.filter(x => x.state.includes("save") || x.state.includes('default'));
      }
    },
    /**
     * Lưu liên kết giữa hóa đơn với giấy rút dự toán
     * DTQUOC 22.11.2023
     */
    async addBuPlanWithdrawReferenceInvoiceAct() {
      if (this._formParam.data && (this._formParam.data.name == 'ViewDebtInvoiceACTPopup' || this._formParam.data.name == 'NotiSystemPopup')) {
        var data = [];
        this._formParam.data.forEach(element => {
          let item = {};
          item = {
            bu_plan_withdraw_id: this.model.ref_id,
            transaction_id: element.transaction_id
          };
          data.push(item);
        });
        await IntegrationACTApi.InsertBuPlanWithdrawReferenceInvoiceAct(data);
      }
    },

    /**
     * Thực hiện các công việc sau khi cất thành công (show toast,...)
     * @param {*} result 
     * NVTUAN1 10.01.2024
     */
    async afterSaveSuccess(result) {
      const me = this;
      me.$toast.success(me.$t('i18nBaseForm.Message.SaveSuccess'));
    },

    /**
     * Lưu xong đóng form
     * @param {*} result
     * @param {*} param
     * NXCHIEN 29.08.2022
     */
    afterSubmitModeSave(result, param) {
      const me = this;

      // NXCHIEN 17.01.2022: tránh trường hợp ghi sổ ko thánh công thì RecordVersion chưa được cập nhật
      me.model = _.cloneDeep(result);
      // gán lại oldDataitem
      me.bindingDetail(me.model);

      me.setFormMode(me.$ms.constant.FormState.View);

      this.$nextTick(() => {
        me.setOldDataItem();
      });

      me.hide();
    },

    /*
     * xử lý sau khi cất thành công của mode view
     * pvduy 04/03/2021
     */
    afterSubmitModeView(result, param) {
      const me = this;
      // gán lại model lấy được từ server để có thêm editversion
      me.model = _.cloneDeep(result);
      // gán lại oldDataitem
      me.bindingDetail(me.model);

      this.$nextTick(() => {
        me.setOldDataItem();
      });

      me.setFormMode(me.$ms.constant.FormState.View);
    },

    /**
     * @override
     * Xử lý đổi link url theo bản ghi hiện tại
     */
    setFormMode(mode) {
      const me = this;
      me.super('setFormMode', BaseDetail, mode);
      me.changeUrlOpenForm();
      if (mode != me.$ms.constant.FormState.View && me.steps && me.stepsDynamic) {
        // nút Cất
        me.stepsDynamic = me.steps.filter(x => x.state?.includes("edit") || x.state?.includes('default'));
      }
    },

    /**
     * Đổi url khi mở form
     * NXCHIEN 12.06.2022
     */
    changeUrlOpenForm() {
      const me = this;
      const config = this.$store.getters[`${this.module}/_config`];
      let id;
      if (config) {
        const { field } = config;
        if (field && field.key) {
          id = this.model[field.key];
        }
      }
      switch (me.editMode) {
        case me.$ms.constant.FormState.Edit:
        case me.$ms.constant.FormState.View:
          me.changeUrl(me._loadParam?.id || id);
          break;
        default:
          me.changeUrl();
          break;
      }
    },

    /**
     * @override Thực hiện các công việc trước khi thêm mới mode SaveNew
     * @param {*} result
     * @param {*} param
     */
    afterSubmitModeSaveNew(result, param) {
      const me = this;

      if (me.$refs) {
        for (let i in me.$refs) {
          //Chỗ này check ref của grid có trường focused hay không mới gán giá trị
          //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
          if (me.$refs[i] && me.$refs[i].hasOwnProperty('focused')) {
            me.$refs[i].focused = false;
          }
        }
      }

      me.add({});
    },

    /**
     * Thực hiện custom lại dữ liệu trước khi bind data ở mode view
     * @param {*} asset
     * @param {*} usageHistory
     */
    customAmountModeView(asset, usageHistory) {
      let quantityAsset = asset.Quantity;
      let quantityUsageHistory = usageHistory.Quantity;

      if (quantityAsset) {
        asset.RemainingAmount = (asset.RemainingAmount / quantityAsset) * quantityUsageHistory;
        asset.OrgAmount = quantityUsageHistory * asset.OrgPrice;
        asset.Quantity = quantityUsageHistory;
      }
    },

    /**
     * Ghi sổ
     * NXCHIEN 26.06.2022
     * dtnga3 (27.07.2022) thêm tham số isSaveSuccess dùng để hiển thị toastMessage cất/ghi sổ thành công nếu tùy chọn Cất và ghi sổ đồng thời
     * NNLINH 03.08.2022 : Sửa truyền vào ignore là 1 mảng
     */
    onPosted(result, isShowInfo, ignore, isSaveSuccess) {
      const me = this;
      // check có quyền ghi sổ hay không - tvhien 12.12.2022
      me.checkActionPermissionAlert(me.$ms.constant.Permission.Posted);
      // validate nghiệp vụ // Type: 1: Các field đang để trống, 3: số tiền = 0
      me.validatePosted().then(mes => {
        if (mes && Object.keys(mes).length > 0) {
          if (isSaveSuccess) {
            me.$toast.success(me.$t('i18nBaseForm.Message.SaveSuccess'));
          }
          let customButton = { Yes: 'Đồng ý', No: 'Hủy' };
          if (mes.type == 1) {
            showConfirmValidate(mes.content, mes.title, customButton).then(answer => {
              if (typeof answer === 'object') {
                let { isClickCustom } = answer;
                if (isClickCustom) {
                  me.handleDirect(me.linkHelpDirect(me.$ms.constant.Help.LedgerVoucher), true);
                }
              } else if (answer) {
                me.afterValidatePosted();
                me.setErrorPost(me.invalidPost);
              }
            });
          } else if (mes.type == 3) {
            showConfirmValidate(mes.content, mes.title, customButton).then(answer => {
              if (answer) {
                me.afterValidatePosted();
              }
            });
          }
        } else {
          //pass validate
          //Khởi tạo param
          let param = {
            ignoreAll: false,
            ignores: ['string'],
            data: {
              refType: result.ref_type,
              refId: result.ref_id,
            },
          };
          //Kiểm tra có truyền vào ignore không?
          if (ignore && ignore.length) {
            param.ignores = [...ignore];
          }

          me.loading = true;
          //Gọi api ghi sổ
          me.$store
            .dispatch(`${me.module}/posted`, param)
            .then(res => {
              if (res.is_success === true) {
                me.postedSuccess(res, isShowInfo, param, isSaveSuccess);
                if (isSaveSuccess) {
                  me.$toast.success(me.$t('i18nBaseForm.Message.SavePostedSuccess'));
                  try {
                    npsFunction.checkSurvey(); //dqvinh 10.2.2023 Kiểm tra khảo sát NPS và hiển thị
                  } catch { }
                }
                // call lại submit khi ghi sổ để dữ liệu bảng kê được chính xác
                if (me.options && typeof me.options.submit === 'function') {
                  me.options.submit();
                }

                // Lưu và đóng form
                if (me.saveAndClose) {
                  me.hide();
                }
              }
            })
            .catch(ex => {
              if (isSaveSuccess) {
                me.$toast.success(me.$t('i18nBaseForm.Message.SaveSuccess'));
              }
              //Show cảnh báo ghi sổ
              const error = ex.response?.data;
              if (error) {
                switch (error.Error) {
                  //Lỗi nghiệp vụ ghi sổ
                  case 'VALIDATE':
                    me.postedError(error, result, isShowInfo, param.ignores);
                    break;
                }
              } else {
                //Không phải lỗi nghiệp vụ
                me.$toast.error('Đã xảy ra lỗi trong quá trình ghi sổ!');
                console.error(ex);
              }
            })
            .finally(() => {
              me.loading = false;
              me.finallyOnPostedCustom();
            });
        }
      });
    },

    /**
     * Hàm xử lý điều hướng
     * NXCHIEN 12.05.2023
     */
    handleDirect(path, isHelp) {
      if (isHelp) {
        window.open(path, '_blank');
      } else {
        if (path && proxy.$route.path != path) {
          let routeData = proxy.$router.resolve({ name: path });
          window.open(routeData.href, '_blank');
        }
      }
    },

    /**
     * Link help
     */
    linkHelpDirect(code, type) {
      type = type || 'mimosa';
      return window._helpLink[type] + window._misaHelp[code];
    },

    /**
     * click đồng ý khi validate ghi sổ
     * NXCHIEN 05.09.2022
     */
    afterValidatePosted() {
      const me = this;
      // đồng ý thì là mode sửa
      me.editMode = me.$ms.constant.FormState.Edit;
      //cập nhật tiêu đề cho form
      me.title = this.getFormTitle(me.$ms.constant.FormState.Edit);
    },

    finallyOnPostedCustom() { },

    /**
     * Bỏ Ghi sổ
     * NXCHIEN 26.06.2022
     */
    onUnPosted(result, isShowInfo, ignore) {
      const me = this;
      // check có quyền bỏ ghi sổ hay không - tvhien 12.12.2022
      me.checkActionPermissionAlert(me.$ms.constant.Permission.UnPost);
      let param = {
        ignoreAll: false,
        ignores: ['string'],
        data: {
          refType: result.ref_type,
          refId: result.ref_id,
        },
      };
      if (ignore) {
        param.ignores.push(ignore);
      }

      me.loading = true;
      me.$store
        .dispatch(`${me.module}/unPosted`, param)
        .then(res => {
          //Hiện tại bỏ ghi không có warning
          me.unPostedSuccess(res, isShowInfo, param);
        })
        .catch(ex => {
          //Show cảnh báo bỏ ghi sổ
          const error = ex.response?.data;
          if (error) {
            switch (error.Error) {
              //Lỗi nghiệp vụ bỏ ghi sổ
              case 'VALIDATE':
                me.unPostedError(error, result, isShowInfo);
                break;
            }
          } else {
            //Không phải lỗi nghiệp vụ
            me.$toast.error('Đã xảy ra lỗi trong quá trình bỏ ghi sổ!');
            console.error(ex);
          }
        })
        .finally(() => {
          me.loading = false;
          me.finallyOnPostedCustom();
        });
    },

    /**
     * Ghi sổ  thành công
     * @param {*} res
     * @param {*} isShowInfo
     * NNLINH 21.07.2022
     */
    postedSuccess(res, isShowInfo, param, isSaveSuccess) {
      const me = this;
      //set is_posted
      me.model.is_posted = true;
      me.model.RecordVersion = res.recordVersion;
      me.oldDataItem.is_posted = true;
      me.oldDataItem.RecordVersion = res.recordVersion;
      //Kiểm tra có hiện thông báo trong option không?
      //Trường hợp thành công nhưng có cảnh báo
      if (res.dataWarning && res.dataWarning.length > 0) {
        if (isShowInfo) {
          showAlertEscapsed(me.$ms.constant.PostedErrorCode[res.dataWarning[0].Code], [], 'Ghi sổ chứng từ');
        }
      } else {
        //Trường hợp thành công
        this.customPostedSuccess(res, param);
        if (isShowInfo) {
          me.$toast.success(me.$t('i18nBaseForm.Message.PostedSuccess'));
          //Nếu không phải là cất đồng thời ghi sổ thì kiểm tra khảo sát NPS
          //Còn nếu là cất đồng thời ghi sổ thì sẽ gọi sau khi cả cất và ghi sổ thành công (gọi ở hàm onPosted khi ghi sổ thành công)
          if (!isSaveSuccess) {
            try {
              npsFunction.checkSurvey(); //dqvinh 10.2.2023 Kiểm tra khảo sát NPS và hiển thị
            } catch { }
          }
        }
      }
      if (me.steps && me.stepsDynamic) {
        me.stepsDynamic = me.steps.filter(x => x.state.includes("posted") || x.state.includes('default'));
      }
    },

    /**
     * Bỏ ghi sổ thành công
     * NNLINH 24.08.2022
     */
    unPostedSuccess(res, isShowInfo, param) {
      const me = this;
      if (res.is_success === true) {
        me.model.is_posted = false;
        me.model.RecordVersion = res.recordVersion;
        me.oldDataItem.is_posted = false;
        me.oldDataItem.RecordVersion = res.recordVersion;
        this.customUnPostedSuccess(res, param);
        //Kiểm tra có hiện thông báo trong option
        if (isShowInfo) {
          me.$toast.success(me.$t('i18nBaseForm.Message.UnPostedSuccess'));
        }
        // Call lại để dữ liệu bảng kê được chính xác
        if (me.options && typeof me.options.submit === 'function') {
          me.options.submit();
        }

        if (me.steps && me.stepsDynamic) {
          me.stepsDynamic = me.steps.filter(x => x.state.includes("unposted") || x.state.includes('default'));
        }
      }
    },

    /**
   * Hàm custom sau khi ghi sổ thành công
   * @param {*} res
   * @param {*} param
   * NNLINH 24.08.2022
   */
    customPostedSuccess(res, param) {
      const me = this;
      //NNLINH 01.02.2023 custom cho phần view linkForm thuế
      if (me.options && typeof me.options.submitViewLinkFormTax === 'function') {
        me.options.submitViewLinkFormTax(res, param);
      }
    },

    /**
     * Hàm custom sau khi bỏ ghi sổ thành công
     * @param {*} res
     * @param {*} param
     * NNLINH 24.08.2022
     */
    customUnPostedSuccess(res, param) { },

    /**
     * Xử lý lỗi khi ghi sổ
     * @param {*} error
     * @param {*} record
     * @param {*} isShowInfo
     * @param ignores mảng mã lỗi bỏ qua
     * NNLINH 21.07.2022
     */
    postedError(error, record, isShowInfo, ignores) {
      const me = this;
      //Kiểm tra xem lỗi loại gì
      switch (error.Data.Type) {
        //Nếu là lỗi thì hiện thông báo lỗi
        case me.$ms.constant.PostedErrorType.Error:
          let errorCode = '',
            mes = '';
          let width;
          //Trường hợp mã lỗi có nhiều lỗi ngăn cách nhau bằng dấu ";"
          if (error.Data.Code.includes(';')) {
            errorCode = error.Data.Code.split(';')
              .map(x => {
                if (x) {
                  return me.$ms.constant.PostedErrorCode[x];
                }
                return null;
              })
              .filter(x => x);
            mes =
              'Bạn cần nhập các thông tin </br>' +
              `- <span class="color-green">${errorCode.join(
                '; '
              )}</span> cho các dòng hạch toán tài khoản <span class="color-green">
                ${error?.Data?.Data?.map(x => x.account_number)?.join(';')}</span></br>` +
              `Nếu bạn không thấy <span class="color-green">` +
              errorCode.join('; ') +
              `</span> trên giao diện chứng từ, vui lòng xem hướng dẫn <a target="_blank" href=${this.$tm('i18nHelpLink.ErrorPosted')} class='text-link customCallBack'>tại đây</a>.`;
          } else {
            //Lỗi ghi sổ VTHH
            if (error && error.Data && error.Data.Code) {
              mes = [];
              switch (error.Data.Code) {
                //Lỗi chưa xác định đích danh phiếu nhập
                case me.$ms.constant.PostedErrorCode.Post_ValidConfrontingRefIDForRealNameCode:
                  error.Data.Data.forEach(x => {
                    let content = me.$ms.constant.PostedErrorCode.Post_ValidConfrontingRefIDForRealName.format(
                      x.inventory_item_code,
                      x.inventory_item_name
                    );

                    if (!mes.includes(content)) {
                      mes.push(content);
                    }
                  });
                  width = 500;
                  break;
                //Lỗi xuất quá số tồn theo kho
                case me.$ms.constant.PostedErrorCode.Post_ValidateOutwardQuantityCode:
                //Lỗi xuất quá số tồn theo số ct đối trừ
                case me.$ms.constant.PostedErrorCode.Post_ValidateOutwardQuantityRealNameCode:
                  //Show popup cảnh báo xuất kho quá số tồn
                  let postedDate = '';
                  if (error.Data.Data[0].posted_date) {
                    //Lấy ra ngày ghi sổ theo định dạng dd/mm/yyyy
                    postedDate = me.$ms.commonFn.getMoment(error.Data.Data[0].posted_date).format('DD/MM/YYYY');
                  }

                  me.showOutWardErrorPopup(error.Data.Data, postedDate);

                  return;
                case me.$ms.constant.PostedErrorCode.Post_ValidFixedAssetIncrement:
                  let msg = '';
                  if (error.Data.Data?.length > 0) {
                    let errorDatas = error.Data.Data.map(x => x.fixed_asset_code);
                    errorDatas = me.$ms.commonFn.distinct(errorDatas);
                    msg = me.$ms.constant.PostedErrorCode.Message_Post_ValidFixedAssetIncrement.format(
                      errorDatas.join(', ')
                    );
                  }
                  showError(msg, 'Ghi sổ không thành công', width);
                  return;
                case me.$ms.constant.PostedErrorCode.Post_ValidFixedAssetDecrement:
                  let msgDecrement = '';
                  if (error.Data.Data?.length > 0) {
                    msgDecrement = me.$ms.constant.PostedErrorCode.Message_Post_ValidFixedAssetDecrement.format(
                      error.Data.Data.map(x => x.fixed_asset_code).join(', ')
                    );
                  }
                  showError(msgDecrement, 'Ghi sổ không thành công', width);
                  return;
                // Lỗi ghi giảm/ điều chuyển quá số lượng
                case me.$ms.constant.PostedErrorCode.Post_ValidQuantityToolCode:
                  //Show popup cảnh báo ghi giảm quá số tồn
                  me.showToolErrorPopup(
                    error.Data.Data,
                    me.$ms.commonFn.getMoment(record?.posted_date).format('DD/MM/YYYY'),
                    false,
                    record?.ref_type
                  );
                  return;
                case me.$ms.constant.PostedErrorCode.Post_ValidAmountToolCode:
                  //Show popup cảnh báo ghi giảm quá số tồn
                  me.showToolErrorPopup(
                    error.Data.Data,
                    me.$ms.commonFn.getMoment(record?.posted_date).format('DD/MM/YYYY'),
                    true,
                    record?.ref_type
                  );
                  return;
                case me.$ms.constant.PostedErrorCode.Post_ValidAmountEstimate:
                  popupUtil.show('ShowConfirmEstimate', {
                    options: {
                      submit: () => {
                        me.editMode = me.$ms.constant.FormState.Edit;
                        me.setErrorEstimatePost(error.Data.Data[0].ErrorMessageEstimate);
                      }
                    }
                  });
                  return;
                default:
                  mes = me.$ms.constant.PostedErrorCode[error.Data.Code];
                  break;
              }
            }
          }
          //Hiển thị thông báo
          showError(mes, 'Ghi sổ không thành công', width).then(answer => {
            if (typeof res === 'object') {
              let { isClickCustom } = res;
              if (isClickCustom) {
                me.handleDirect(me.linkHelpDirect(me.$ms.constant.Help.LedgerVoucher), true);
              }
            } else if (answer) {
              // đồng ý thì là chuyển mode sửa
              me.editMode = me.$ms.constant.FormState.Edit;
            }
          });
          break;
        // Trường hợp lỗi dạng question Yes/No
        case me.$ms.constant.PostedErrorType.Question:
          let accountNumber, date, amount;
          //Lấy dữ liệu lỗi nếu có để hiển thị thông báo
          if (error.Data && error.Data.Data.length) {
            accountNumber = error.Data.Data[0].account_number;
            date = me.$ms.format.formatDate(error.Data.Data[0].date);
            amount =
              me.$ms.format.formatAmount(error.Data.Data[0].amount, {
                formatType: me.$ms.constant.FormatType.Amount,
              }) || 0;
          }

          let title = 'Ghi sổ chứng từ';
          switch (error.Data.Code) {
            case 'Post_QuestionClosingDebit':
              title = 'Quỹ tiền âm';
              break;
            default:
              break;
          }
          showConfirm(me.$ms.constant.PostedErrorCode[error.Data.Code].format(accountNumber, date, amount), title).then(
            answer => {
              if (answer) {
                ignores.push(error.Data.Code);
                // đồng ý thì truyền vào ignore là mã code cảnh báo và gọi lại hàm ghi sổ
                me.onPosted(record, isShowInfo, ignores);
              }
            }
          );
          break;
        // Trường hợp lỗi dạng cảnh báo
        case me.$ms.constant.PostedErrorType.Warning:
          showAlertEscapsed(me.$ms.constant.PostedErrorCode[error.Data.Code], [], 'Ghi sổ chứng từ');
          break;
      }
    },

    /**
     * Xử lý lỗi bỏ ghi sổ
     * @param {*} error
     * @param {*} record
     * NNLINH 21.07.2022
     */
    unPostedError(error, record, isShowInfo) {
      const me = this;
      //NOTE: Bỏ ghi sổ chỉ có error và yes/no
      switch (error.Data.Type) {
        //Nếu là lỗi thì hiện thông báo lỗi
        case me.$ms.constant.PostedErrorType.Error:
          me.showErrorUnPosted(error);
          break;
        // case thông báo dạng  question yes/no
        case me.$ms.constant.PostedErrorType.Question:
          me.showQuestionUnposted(error, record, isShowInfo);
          break;
      }
    },

    /**
     * Show lỗi bỏ ghi sổ
     * @param {*} error
     * NNLINH 22.07.2022
     */
    showErrorUnPosted(error) {
      const me = this;
      let dataError, title, mes, button;
      if (error.Data && error.Data.Code) {
        switch (error.Data.Code) {
          //Lỗi bỏ ghi sổ bản ghi đã lập bảng kê và thanh toán không thể bỏ ghi sổ
          case me.$ms.constant.PostedErrorCode.UnPost_ErrorExistInBUVoucherList_Code:
            // setup giá trị của thông báo
            (dataError = error.Data.Data[0]),
              (title = me.$ms.constant.PostedErrorCode.UnPost_ErrorExistInBUVoucherList_Title),
              (mes = me.$ms.constant.PostedErrorCode.UnPost_ErrorExistInBUVoucherList.format(
                dataError ? dataError.exception_ref_no : ''
              )),
              (button = me.$ms.constant.PostedErrorCode.UnPost_ErrorExistInBUVoucherList_Button);
            //Hiển thị thông báo
            showConfirmValidateCustom(mes, title, button).then(answer => {
              if (answer) {
                //Nếu đồng ý xem bảng kê
                // Lấy form detail name
                let formDetailName = me.getFormDetailName(dataError ? dataError.exception_ref_type : '');
                // chọn xem bảng kê thì mở form bảng kê
                popupUtil.show(formDetailName, {
                  mode: me.$ms.constant.FormState.View,
                  id: dataError ? dataError.exception_ref_id : null,
                  data: dataError,
                  options: {},
                });
              }
            });
            break;
          case me.$ms.constant.PostedErrorCode.UnPost_Warning_OutwardBeUpdated_Code:
            dataError = error.Data.Data ?? '';
            button = me.$ms.constant.PostedErrorCode.UnPost_Warning_OutwardBeUpdated_Button;
            title = me.$ms.constant.PostedErrorCode.UnPost_Warning_OutwardBeUpdated_Title;

            mes = me.$ms.constant.PostedErrorCode.UnPost_Warning_OutwardBeUpdated.format(
              dataError[0] ? dataError[0].inward_ref_no : '',
              dataError ? dataError.map(x => x.ref_no_outward).join(', ') : ''
            );

            //Thông báo
            showConfirmValidateCustom(mes, title, button);
            break;
          default:
            break;
        }
      }
    },

    /**
     * Show question yes/no bỏ ghi sổ
     * NNLINH 22.07.2022
     * modified by HQMinh1 14.10.2022
     */
    showQuestionUnposted(error, record, isShowInfo) {
      const me = this;
      if (error.Data && error.Data.Code) {
        switch (error.Data.Code) {
          //Trường hợp chứng từ bảng ghi sổ hoặc bảng tổng hợp hoặc cả bảng tổng hợp và chứng từ ghi sổ
          case me.$ms.constant.PostedErrorCode.UnPost_ErrorUnPostExistInGLVoucherList_Code:
            //check là loại chứng từ bảng TH hay chứng từ ghi sổ
            //Lọc ra các chứng từ ghi sổ hoặc bảng tổng hợp
            let dataSummary =
              error.Data.Data.filter(x => x.ref_type == me.$ms.constant.RefType.GLVoucherSummaryTable) ?? [],
              dataVoucher = error.Data.Data.filter(x => x.ref_type == me.$ms.constant.RefType.GLPostedVoucher) ?? [],
              mess = '';

            let valSummary, valVoucher;
            // Danh sách mã các chứng từ bảng tổng hợp
            if (dataSummary && dataSummary.length) {
              dataSummary = this.$ms.commonFn.distinct(dataSummary);
              valSummary = dataSummary.map(x => x.ref_no).join('; ');
            }
            // Danh sách mã các chứng từ ghi sổ
            if (dataVoucher && dataVoucher.length) {
              dataVoucher = this.$ms.commonFn.distinct(dataVoucher);
              valVoucher = dataVoucher.map(x => x.ref_no).join('; ');
            }

            switch (true) {
              case dataSummary.length > 0 && dataVoucher.length > 0:
                //Trường hợp có cả ghi sổ và bảng th cùng loại
                mess = me.$ms.constant.PostedErrorCode.UnPost_ErrorUnPostExistInGLVoucherList_All.format(
                  valSummary,
                  record.ref_no,
                  valVoucher
                );
                break;
              case dataSummary.length > 0 && dataVoucher.length == 0:
                //Trường hợp chỉ có bảng th cùng loại
                mess = me.$ms.constant.PostedErrorCode.UnPost_ErrorUnPostExistInGLVoucherList_Summary.format(
                  valSummary,
                  record.ref_no
                );
                break;
              case dataSummary.length == 0 && dataVoucher.length > 0:
                //Trường hợp chỉ có ghi sổ
                mess = me.$ms.constant.PostedErrorCode.UnPost_ErrorUnPostExistInGLVoucherList_Voucher.format(
                  valVoucher,
                  record.ref_no
                );
                break;
              default:
                mess = '';
                break;
            }
            // Hiển thị cảnh báo
            if (mess != '') {
              showConfirm(mess, 'Cảnh báo bỏ ghi sổ').then(answer => {
                if (answer) {
                  me.onUnPosted(record, isShowInfo, error.Data.Code);
                }
              });
            }
            break;
          default:
            // trường hợp khác
            let valRefNo;
            //Lấy danh sách các mã chứng từ cảnh báo
            if (error.Data.Data && error.Data.Data.length) {
              valRefNo = error.Data.Data.map(x => x.ref_no).join('; ');
              let mess = me.$ms.constant.PostedErrorCode[error.Data.Code].format(valRefNo);
              // Hiển thị thông báo
              showConfirm(mess, 'Cảnh báo bỏ ghi sổ').then(answer => {
                if (answer) {
                  //Nếu đồng ý gọi lại hàm bỏ ghi và truyền vào mã lỗi
                  me.onUnPosted(record, isShowInfo, error.Data.Code);
                }
              });
            }
            break;
        }
      }
    },
    /**
     * Validate ghi sổ
     * NXCHIEN 11.07.2022
     */
    async validatePosted() {
      return {};
    },

    /**
     * Get name form detail bằng ref_type
     * @param {int} refType
     * @returns formDetailName
     * NNLINH 17.07.2022
     */
    getFormDetailName(refType) {
      const me = this;
      // lấy tên form detail để show
      let formDetailName;
      Object.keys(me.$ms.constant.RefTypeMapperDetailName).forEach(item => {
        if (
          (Array.isArray(me.$ms.constant.RefTypeMapperDetailName[item]) &&
            me.$ms.constant.RefTypeMapperDetailName[item].find(x => x == refType)) ||
          (Number.isInteger(me.$ms.constant.RefTypeMapperDetailName[item]) &&
            me.$ms.constant.RefTypeMapperDetailName[item] == refType)
        ) {
          formDetailName = item;
        }
      });
      return formDetailName;
    },

    /**
     * Thực hiện show popup cảnh báo xuất quá số tồn
     * @param {*} data
     * @param {*} postedDate
     * NVTUAN1 08.09.2022
     */
    showOutWardErrorPopup(data, postedDate) {
      var me = this;
      popupUtil.show('OutWardErrorPopup', {
        data: {
          dataGrid: data,
          isSave: false,
          postedDate: postedDate,
        },
        options: {},
      });
    },

    /**
     * Thực hiện show popup cảnh báo điều chuyển ccdc quá số tồn
     * lttuan1 - 04.01.2023
     */
    showToolErrorPopup(data, postedDate, isAmount, refType) {
      var me = this;
      popupUtil.show('TransferToolErrorPopup', {
        data: {
          isAmount: isAmount,
          dataGrid: data,
          isSave: false,
          postedDate: postedDate,
          keyColumnDepartment: 'department_code',
          refType: refType,
        },
        options: {},
      });
    },
  },
  /**
   * Trước khi destroy form
   */
  beforeUnmount() {
    let me = this;

    // me.removeHandler();

    //destroy cha của form sẽ ăn phím tắt
    if (me.hasShortKey) {
      // this.$ms.commonFn.shortkeyPopView(this.$el);
    }
  },

  /**
   * Sự kiện khi chuyển sang router khác
   */
  beforeRouteLeave(to, from, next) {
    //Lưu lại thông tin của form
    // this.saveState();
    next();
  },
};
